import { Chip } from "@mui/material";
import { ReactComponent as FlagIcon } from "../assets/tile-tags/flag.svg";
import { ReactComponent as BoltIcon } from "../assets/tile-tags/bolt.svg";
import { ReactComponent as DiamondIcon } from "../assets/tile-tags/diamond.svg";
import { JSX } from "react";

interface TagDefinition {
  icon: JSX.Element;
}

const TileTag = (props: { tag: string; label: string }) => {
  const tagDefintions: Record<string, TagDefinition> = {
    offline: {
      icon: <BoltIcon />,
    },
    coming: {
      icon: <FlagIcon />,
    },
    new: {
      icon: <DiamondIcon />,
    },
  };

  const tagDefinition = tagDefintions[props.tag];
  if (!tagDefinition) {
    return <></>;
  }

  return (
    <Chip
      size="small"
      variant={props.tag as "new" | "coming" | "offline"}
      label={props.label}
      icon={
        tagDefinition.icon
      }
    />
  );
};

export default TileTag;
